<template>
  <div v-if="isVisible">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="exchange-success-modal" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">
      <div class="popup-header" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">兑换成功</div>
      <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="close-btn"  @click="closePopup" alt="">

      <div class="gift-box">
        <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['fengyou']['exchangePic'][target]}`" alt="礼品盒" class="gift-img" />
      </div>

      <p class="success-desc" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">
        已兑换成功，您可前往对应平台APP、小程序等查看相关权益。
        <span href="#" class="detail-link" :style="`color: ${h5ConfigDetails[0]['fontColor']['noticeTxtColor'][0]};`" @click="_jump_fengyou_intro">点击查看详细情况>></span> 
      </p>

      <div class="confirm-btn" @click="closePopup" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnBg'][0]};`">我知道了</div>
    </div>
  </div>
</template>

<script>
import ModalMask from '@/components/modal/ModalMask'
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'

export default {
  name: 'ExchangeSuccessPopup',
  data () {
    return {
      baseUrl
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '-1'
    },
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath'])
  },
  components: { ModalMask },
  methods: {
    closePopup() {
      this.$emit('close-modal')
    },
    _jump_fengyou_intro () {
      this.$router.push({name:'FengyouIntro', query:{target: this.target}})
    }
  }
};
</script>

<style scoped lang="less">
@import '../../style/mixin';

.exchange-success-modal {
  .modal-common;
  width: 29.7rem;
  height: 25.3rem;
  background: #FFF7EE;
  text-align: center;
  border-radius: .9rem;
  padding: 1.7rem 2.1rem 1.4rem;
}

.popup-header {
  position: relative;
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.8rem;
  color: #7E3E1B;
}

.close-btn {
  position: absolute;
  top: .8rem;
  right: 1.1rem;
  width: 1.9rem;
  height: 1.9rem;
}

.gift-img {
  width: 9.2rem;
  height: auto;
  margin-bottom: .5rem;
}

.success-desc {
  font-weight: 400;
  font-size: 1.1rem;
  color: #A9420B;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 2.5rem;
}

.detail-link {
  color: #FF5258;
  text-decoration: none;
}

.confirm-btn {
  width: 25.4rem;
  height: 4rem;
  line-height: 4rem;
  background: #FA733C;
  border-radius: 2rem;
  font-weight: 600;
  font-size: 1.6rem;
  color: #FFF;
}
</style>